import { fadeInAnimation, flexCenter } from '@anm/styles/helpers';

import { VideoSizes } from '@anm/hosting-player';
import styled, { css } from 'styled-components';

export const Placeholder = styled.div<{ sizes?: VideoSizes }>`
  ${flexCenter};
  background: #ebeef5;
  margin: 0 auto;
  position: relative;

  ${({ sizes }) => css`
    width: ${sizes?.width}px;
    height: ${sizes?.height}px;
  `}
`;

export const FadeInWrapper = styled.div<{ inited: boolean }>`
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  ${({ inited }) => inited && fadeInAnimation}
`;
